export interface ISystemPointHistory {
    historyExists: boolean;
    lastTimestamp: Date;
    firstTimestamp: Date;
}

export class SystemPointHistory implements ISystemPointHistory {
    historyExists: boolean;
    lastTimestamp: Date;
    firstTimestamp: Date;

    constructor(historyExists: boolean,
        lastTimestamp: Date,
        firstTimestamp: Date) {
        this.historyExists = historyExists;
        this.lastTimestamp = lastTimestamp;
        this.firstTimestamp = firstTimestamp;
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/systemHealthRetriever/system-point-history.ts
 **/